import { render, staticRenderFns } from "./Funding.vue?vue&type=template&id=79693053&scoped=true"
import script from "./Funding.vue?vue&type=script&lang=js"
export * from "./Funding.vue?vue&type=script&lang=js"
import style0 from "./Funding.vue?vue&type=style&index=0&id=79693053&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79693053",
  null
  
)

export default component.exports